import { render, staticRenderFns } from "./StudentInEachUnit.vue?vue&type=template&id=d8414b60&functional=true&"
import script from "./StudentInEachUnit.vue?vue&type=script&lang=js&"
export * from "./StudentInEachUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports